import React, { Component, useRef } from "react";
// import Switch from "react-switch";
import axios from "axios";
// import * as io from "socket.io-client";
import io from "socket.io-client";
// import "../../../styles/App.css";
// import { InputLabel, Select, MenuItem } from "@material-ui/core";
// import { makeStyles } from "@material-ui/core/styles";
// import TextField from "@material-ui/core/TextField";
// import MomentInput from "react-moment-input";
// import moment from "moment";
// import Typography from "@material-ui/core/Typography";
import ControlModel from "./ControlModel";
import TextField from "@material-ui/core/TextField";
import { InputLabel, Select, MenuItem } from "@material-ui/core";
// import ControlModel from ''

// var mqtt = require("mqtt");
// var host = "ws://192.168.0.199:3000";
// var options = {
//   keepalive: 3600,
//   protocolId: "MQTT",
//   protocolVersion: 4,
//   clean: true,
//   reconnectPeriod: 1000,
//   connectTimeout: 30 * 1000,
//   will: {
//     topic: "WillMsg",
//     payload: "Connection Closed abnormally..!",
//     qos: 0,
//     retain: false,
//   },
//   username: "",
//   password: "",
//   rejectUnauthorized: false,
// };
// var mqttClient = mqtt.connect(host, options);

// const MQTT = require("async-mqtt");
// const client = MQTT.connect("tcp://192.168.0.199:3000");

const styles = (theme) => ({
  textField: {
    width: "90%",
    marginLeft: "auto",
    marginRight: "auto",
    paddingBottom: 0,
    marginTop: 0,
    fontWeight: 500,
  },
  input: {
    color: "white",
  },
});

var controller = ControlModel()

var output = null;
var setPoint = null;
var currentValue = null;
var delayInMilliseconds = 10000
class PIDInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      DefaultChecked: props.message,
      checked: "not yet",
      flag: false,
      topic: props.topic,
      currentMode: "0",
      changeModeTo: "",
      time: "",

      p: 1536,
      i: 576,
      d: 0,
      oMax: 10000,
      oMin: 6000,
      oThreshold: 6000,
      itermMax: 90,
      itermMin: 0,
      setPointId: "0", // 17
      changeSetPointIdTo: null,
      currentValueId: "0", //09
      changeCurrentValueIdTo: null,
      flagCurrentValueId: false,
      flagSetPointId: false,
      setPoint: null,
      currentValue: null,
    };
  }

  onChangeHandle = (evt) => {
      this.setState({
        [evt.target.name]: parseInt(evt.target.value)
      });
    };

    handleChangeCurrentValue = (evt) => {
        this.setState({changeCurrentValueIdTo : evt.target.value, flagCurrentValueId : true})
    }
    handleChangeSetPoint = (evt) => {
        this.setState({changeSetPointIdTo : evt.target.value, flagSetPointId : true})
    }

  componentWillMount() {
    const {p, i, d, oMax, oMin, oThreshold, itermMax, itermMin} = this.state
    const {setPoint_1, setPoint_2, currentValue_1, currentValue_2, currentValue_3} = this.props
    controller.setOutput(oMin, oMax, oThreshold);
    controller.setGains(p, i, d);
    controller.setItermLimit(itermMin, itermMax);
  }

  componentDidUpdate(prevState, prevProps) {
    const {p, i, d, oMax, oMin, oThreshold, itermMax, itermMin} = this.state
    const {setPoint_1, setPoint_2, currentValue_1, currentValue_2, currentValue_3} = this.props

      if ((setPoint_1 && prevProps.setPoint_1 !== setPoint_1) && this.state.changeSetPointIdTo == '17') {
        controller.setTarget(setPoint_1)
        setPoint = setPoint_1
      }
      if ((setPoint_2 && prevProps.setPoint_2 !== setPoint_2) && this.state.changeSetPointIdTo == '21') {
        controller.setTarget(setPoint_2)
        setPoint = setPoint_2
      }
      if ((setPoint_1 && prevProps.setPoint_1 !== setPoint_1) && this.state.changeSetPointIdTo == null && this.props.takeSetPoint_1 == 1) {
        controller.setTarget(setPoint_1)
        setPoint = setPoint_1
      }
      if ((setPoint_2 && prevProps.setPoint_2 !== setPoint_2) && this.state.changeSetPointIdTo == null && this.props.takeSetPoint_2 == 1) {
        controller.setTarget(setPoint_2)
        setPoint = setPoint_2
      }
      console.log(this.props.message)
      if ((currentValue_1 && currentValue_2)&&(this.state.changeSetPointIdTo !== '17' && this.state.changeSetPointIdTo !== '21') && (this.props.takeSetPoint_1 == 0  && this.props.takeSetPoint_2 == 0) && this.props.message !== 10001){
        // setTimeout(
        //   mqttClient.publish(
        //     "hamk/iot/valkeakoski/kontti/ui/" + this.props.topic,
        //     '10001'
        //     ),
        //   delayInMilliseconds
        // )
      }

      if ((currentValue_1) && this.state.changeCurrentValueIdTo == '09' && setPoint) {
        console.log(controller.run(currentValue_1))
        output = controller.run(currentValue_1)
        currentValue = currentValue_1
        // if (output >= 4000 && output <= 10000) {
        // mqttClient.publish(
        //   "hamk/iot/valkeakoski/kontti/ui/" + this.props.topic,
        //   output.toString()
        // );
        // }
      }

      if ((currentValue_2) && this.state.changeCurrentValueIdTo == '11' && setPoint) {
        console.log(controller.run(currentValue_2))
        output = controller.run(currentValue_2)
        currentValue = currentValue_2
        // if (output >= 4000 && output <= 10000) {
        //   mqttClient.publish(
        //     "hamk/iot/valkeakoski/kontti/ui/" + this.props.topic,
        //     output.toString()
        //   );
        //   }
      }

      if ((currentValue_3) && this.state.changeCurrentValueIdTo == '13' && setPoint) {
        console.log(controller.run(currentValue_3))
        output = controller.run(currentValue_3)
        currentValue = currentValue_3
        // if (output >= 4000 && output <= 10000) {
        //   mqttClient.publish(
        //     "hamk/iot/valkeakoski/kontti/ui/" + this.props.topic,
        //     output.toString()
        //   );  
        //   }
      }

      if ((currentValue_1) && this.state.changeCurrentValueIdTo == null && setPoint) {
        console.log(controller.run(currentValue_1))
        output = controller.run(currentValue_1)
        currentValue = currentValue_1
        // if (output >= 4000 && output <= 10000) {
        //   mqttClient.publish(
        //     "hamk/iot/valkeakoski/kontti/ui/" + this.props.topic,
        //     output.toString()
        //   );
        //   }
      }

    if ((p && prevState.p !== p) || (i && prevState.i !== i) || (d && prevState.d !== d)) {
        controller.setGains(p, i, d)
    }
    if ((itermMin && prevState.itermMin !== itermMin) || (itermMax && prevState.itermMax !== itermMax)) {
        controller.setItermLimit(itermMin, itermMax)
    }
    if ((oMin && prevState.oMin !== oMin) || (oMin && prevState.oMin !== oMin) || (oThreshold && prevState.oThreshold !== oThreshold)) {
        controller.setOutput(oMin, oMax, oThreshold)
    }
  };

  render(prevProps, prevState) {
    return (
      <label>
        <div>
          <form noValidate autoComplete="off">
            <TextField
              required
              id="filled-required"
              label="TERM - P"
              name="p"
              defaultValue={this.state.p}
              variant="filled"
              inputProps={{
                style: {
                  textAlign: "center",
                  color: "white",
                },
                input: "white",
              }}
              InputLabelProps={{
                style: { color: "Red" },
              }}
              onChange={this.onChangeHandle}
            />
            <TextField
              required
              id="filled-required"
              label="TERM - I"
              name="i"
              defaultValue={this.state.i}
              variant="filled"
              inputProps={{
                style: { textAlign: "center", color: "white" },
                input: "white",
              }}
              InputLabelProps={{
                style: { color: "Red" },
              }}
            />
            <TextField
              required
              id="filled-required"
              label="TERM - D"
              name="d"
              defaultValue={this.state.d}
              variant="filled"
              inputProps={{
                style: { textAlign: "center", color: "white" },
                input: "white",
              }}
              InputLabelProps={{
                style: { color: "Red" },
              }}
              onChange={this.onChangeHandle}
            />
          </form>
        </div>
        <div style={{ marginLeft: "auto" }}>
          <form noValidate autoComplete="off">
            <TextField
              required
              id="filled-required"
              label="OUTPUT - Upper limit"
              name="oMax"
              defaultValue={this.state.oMax}
              variant="filled"
              inputProps={{
                style: {
                  textAlign: "center",
                  color: "white",
                },
                input: "white",
              }}
              InputLabelProps={{
                style: { color: "Red" },
              }}
              onChange={this.onChangeHandle}
            />
            <TextField
              required
              id="filled-required"
              label="OUTPUT - Below limit"
              name="oMin"
              defaultValue={this.state.oMin}
              variant="filled"
              inputProps={{
                style: {
                  textAlign: "center",
                  color: "white",
                },
                input: "white",
              }}
              InputLabelProps={{
                style: { color: "Red" },
              }}
              onChange={this.onChangeHandle}
            />
            <TextField
              required
              id="filled-required"
              label="Threshold limit"
              name="oThreshold"
              defaultValue={this.state.oThreshold}
              variant="filled"
              inputProps={{
                style: {
                  textAlign: "center",
                  color: "white",
                },
                input: "white",
              }}
              InputLabelProps={{
                style: { color: "Red" },
              }}
              onChange={this.onChangeHandle}
            />
          </form>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "left",
            alignItems: "left",
            marginLeft: "auto",
          }}
        >
          <form noValidate autoComplete="off">
            <TextField
              required
              id="filled-required"
              label="Iterm - max limit"
              name="itermMax"
              defaultValue={this.state.itermMax}
              variant="filled"
              inputProps={{
                style: {
                  textAlign: "center",
                  color: "white",
                },
                input: "white",
              }}
              InputLabelProps={{
                style: { color: "Red" },
              }}
              onChange={this.onChangeHandle}
            />
            <TextField
              required
              id="filled-required"
              label="Iterm - min limit"
              name="itermMin"
              defaultValue={this.state.itermMin}
              variant="filled"
              inputProps={{
                style: {
                  textAlign: "center",
                  color: "white",
                },
                input: "white",
              }}
              InputLabelProps={{
                style: { color: "Red" },
              }}
              onChange={this.onChangeHandle}
            />
          </form>
        </div>
        <label
          style={{
            display: "flex",
            justifyContent: "left",
            alignItems: "left",
            marginLeft: "auto",
          }}
        >
          <div style={{ marginLeft: "auto" }}>
            <h>CurrentValueId</h>
            <Select
              style={{
                color: "red",
              }}
              labelId="label"
              id="select"
              name="changeCurrentValueIdTo"
              value={
                this.state.flagCurrentValueId == false
                  ? this.state.currentValueId
                  : this.state.changeCurrentValueIdTo
              }
              onChange={this.handleChangeCurrentValue}
            >
              <MenuItem value="0">Off</MenuItem>
              <MenuItem value="09">TE-009</MenuItem>
              <MenuItem value="11">TE-011</MenuItem>
              <MenuItem value="13">TE-013</MenuItem>
            </Select>
            <h>SetPointId</h>
            <Select
              style={{
                color: "red",
              }}
              labelId="label"
              id="select"
              name="changeSetPointIdTo"
              value={
                this.state.flagSetPointId == false
                  ? this.state.setPointId
                  : this.state.changeSetPointIdTo
              }
              onChange={this.handleChangeSetPoint}
            >
              <MenuItem value="0">Off</MenuItem>
              <MenuItem value="17">TE-017</MenuItem>
              <MenuItem value="21">TE-021</MenuItem>
            </Select>
          </div>
          <div style={{ marginLeft: "auto" }}>
            {/* <ControlModel
              p={this.state.p}
              i={this.state.i}
              d={this.state.d}
              oMax={this.state.oMax}
              oMin={this.state.oMin}
              oThreshold={this.state.oThreshold}
              itermMax={this.state.itermMax}
              itermMin={this.state.itermMin}
              setPoint={this.props.setPoint_1}
              currentValue={
                this.props.currentValue_1
              }
            /> */}
            <p>Set Point: {setPoint}</p>
            <p>Current Value: {currentValue}</p>
            <p>Output: {output}</p>
          </div>
        </label>
      </label>
    );
  }
}

export default PIDInput;
